import { compact } from 'lodash';
import { UnitStatusSearchForm } from '@mark43/cad-api';
import { formatMonthDayHoursMinutes } from '../common/helpers/utils';
import {
    formatBoolean,
    formatLocations,
    formatOption,
    formatOptions,
    formatString,
    formatStrings,
} from '../search-windows/form-value-formatters';

export function formatUnitStatusSearchForm(form: UnitStatusSearchForm, subpremiseSupport: boolean) {
    return compact([
        formatOptions('Units', form.units),
        formatOptions('Personnel', form.personnel),
        formatOptions('Plate #', form.vehicleTags),
        formatOptions('Unit D-Areas', form.dispatchAreas),
        formatOptions('Stations', form.stations),
        formatOptions('Hospitals', form.hospitals),
        formatOptions('Transitioned By', form.transitionedBy),
        formatOptions('Agencies', form.agencyProfiles),
        formatOption('Agency Type', form.agencyType),
        formatString('Narrative Keywords', form.narrativeKeywords),
        formatOption('Time Range', form.timeRangeOption),
        formatString(
            'Date Range Start',
            form.dateRange?.start ? formatMonthDayHoursMinutes(form.dateRange.start) : undefined
        ),
        formatString(
            'Date Range End',
            form.dateRange?.end ? formatMonthDayHoursMinutes(form.dateRange.end) : undefined
        ),
        formatOptions('Statuses', form.unitStates),

        formatLocations(form.locations, subpremiseSupport),
        formatStrings(
            'Polygon',
            form.polygonPoints.map(({ latitude, longitude }) =>
                latitude !== undefined && longitude !== undefined
                    ? `${latitude}/${longitude}`
                    : undefined
            )
        ),

        formatString('CAD Event #', form.eventNumber),
        formatOptions('Call Origins', form.eventOrigins),
        formatOptions('Calls For Service', form.callForServices),
        formatOptions('Priority Levels', form.priorities),

        formatBoolean('Enable Fuzzy Matching', form.fuzzyMatchingEnabled),
    ]).join(', ');
}
